/* eslint-disable prettier/prettier */
import Swiper from 'swiper';

export const initFeaturedProduct = () => {
  new Swiper('.product__container', {
    slidesPerView: 'auto',
    breakpoints: {
      375: {
        slidesPerView: 1.3496,
        spaceBetween: 16,
      },
      1024: {
        slidesPerView: 3.5,
        spaceBetween: 32,
      },
      1280: {
        slidesPerView: 4,
        spaceBetween: 32,
      },
    },
    on: {
      afterInit: function () {
        let herbWrappers = document.querySelectorAll('.product__wrapper');
        herbWrappers?.forEach((herbWrapper) => {
          herbWrapper?.classList.remove('gap-4', 'lg:gap-8');
        });
      },
    },
  });
};
